import { MENU_JIAMENG_ORDER, ORDER_PATH } from '@constant'

export default {
  key: MENU_JIAMENG_ORDER,
  id: '',
  title: '订单',
  icon: 'icon-dingdan',
  link: ORDER_PATH
}
